import Model from "@/lib/model/model";

export default class ModalTitle extends Model {
  title = ""; //modal框标题
  desc = ""; //modal框描述
  hasDesc = false; // 是否有描述内容
}
